import { datadogRum } from '@datadog/browser-rum';
import { logger } from '@tecma/logs-fe';
import { DATADOG_CONFIG } from 'components/Tracking/Tracking';

// eslint-disable-next-line import/prefer-default-export
export class TrackingService {
  constructor() {
    this.isInitialized = false;
  }

  static getInstance() {
    if (!TrackingService.instance) {
      TrackingService.instance = new TrackingService();
    }
    return TrackingService.instance;
  }

  /**
   * Initialize tracking if the project is configured
   */
  initializeTracking() {
    try {
      this.initializeDatadog();
      this.isInitialized = true;
      logger.info('tracking initialized');
    } catch (error) {
      logger.error('Error during tracking initialization:', error);
    }
  }

  /**
   * Inizializza Datadog
   */
  initializeDatadog() {
    if (this.isInitialized) return;

    datadogRum.init({
      applicationId: DATADOG_CONFIG.applicationId,
      clientToken: DATADOG_CONFIG.clientToken,
      site: DATADOG_CONFIG.site,
      service: DATADOG_CONFIG.service,
      env: process.env.REACT_APP_NAMESPACE,
      sessionSampleRate: DATADOG_CONFIG.sessionSampleRate,
      sessionReplaySampleRate: DATADOG_CONFIG.sessionReplaySampleRate,
      defaultPrivacyLevel: DATADOG_CONFIG.defaultPrivacyLevel,
      trackUserInteractions: DATADOG_CONFIG.trackUserInteractions,
      trackResources: DATADOG_CONFIG.trackResources,
      trackLongTasks: DATADOG_CONFIG.trackLongTasks,
    });
  }

  /**
   * Send a custom event to Datadog
   */
  trackEvent(eventName, attributes) {
    if (!this.isInitialized) return;

    try {
      datadogRum.addAction(eventName, attributes);
      logger.debug(`Datadog event sent: ${eventName}`, attributes);
    } catch (error) {
      logger.error('Error during event sending to Datadog:', error);
    }
  }

  /**
   * Send an error to Datadog
   */
  trackError(error, context) {
    if (!this.isInitialized) return;

    try {
      datadogRum.addError(error, context);
      logger.debug('Error sent to Datadog:', error, context);
    } catch (trackingError) {
      logger.error('Error during error sending to Datadog:', trackingError);
    }
  }
}
